import React from 'react';
import { Segment, Label } from 'semantic-ui-react';

import TargetLink from '../../components/target-link';
import { WHATS_NEW } from '../../utils/whats-new';

const { origin } = window.location;
const NOTHING_NEW = origin.match(/theinfluencer/);
const WhatsNew = () => {
  const { link, text } = WHATS_NEW;
  if (NOTHING_NEW) return null;
  return (
    <Segment raised>
      <Label as="span" color="pink" ribbon>
           What’s new in Dyzio!
      </Label>
      { text }... <TargetLink renderIf href={link}>click here</TargetLink>
    </Segment>
  );
};

export default WhatsNew;



/** WEBPACK FOOTER **
 ** ./src/components/whats-new/index.js
 **/